import { hashCode } from "@/helpers/Misc";
import StructurePreprocessing from "../Structure/StructurePreprocessing";
import Events from "./Events";
import EventFunctionsLib from "./EventFunctionsLib";
import type FormEngine from "../FormEngine";

export default class EventSystem {
  public static list = Events;
  public static eventFunctionsLibrary = EventFunctionsLib;

  public static globalListeners: Dictionary<Map<string, any>> = {};
  public static namedListeners: Dictionary<Dictionary<Map<string, any>>> = {};

  static initialize() {
    this.eventFunctionsLibrary = Object.assign(EventFunctionsLib, window.eventFunctionsLibrary);
    this.subscribeDefaultEvents();
  }
  /**
   *
   * @param eventName - flat structure with . notation
   * @param callback - function used for callback
   * @param context - context in which to use said function
   */
  static subscribe(eventName: string, callback: Function, identifier?: string | null, subscriberSpecifier?: string, context?: any): string | null {
    let callbackHashCode = (hashCode(callback.toString()).toString() + (subscriberSpecifier ? "-" + subscriberSpecifier : "")) as string;

    if (identifier) {
      if (!this.namedListeners[identifier]) {
        this.namedListeners[identifier] = {};
      }
      if (!this.namedListeners[identifier][eventName]) {
        this.namedListeners[identifier][eventName] = new Map();
      }
      if (!this.namedListeners[identifier][eventName].get(callbackHashCode)) {
        if (context) {
          this.namedListeners[identifier][eventName].set(callbackHashCode, {
            _context: context,
            _callback: callback,
          });
        } else {
          this.namedListeners[identifier][eventName].set(callbackHashCode, {
            _context: window.FormEngine,
            _callback: callback,
          });
        }
        return callbackHashCode;
      }
    } else {
      if (!this.globalListeners[eventName]) {
        this.globalListeners[eventName] = new Map();
      }

      /*    if (isUniqueInstance(context)) {
      callbackHashCode += context.guid.toString();
    } */

      if (!this.globalListeners[eventName].get(callbackHashCode)) {
        if (context) {
          this.globalListeners[eventName].set(callbackHashCode, {
            _callbackHash: callbackHashCode,
            _context: context,
            _callback: callback,
          });
        } else {
          this.globalListeners[eventName].set(callbackHashCode, {
            _callbackHash: callbackHashCode,
            _context: window.FormEngine,
            _callback: callback,
          });
        }
        return callbackHashCode;
      }
    }
    return null;
  }
  static publish(eventName: string, data: any, identifier?: string): Array<any> {
    let results = [];
    if (identifier) {
      if (!this.namedListeners[identifier] || !this.namedListeners[identifier][eventName]) return [];
      for (let [key, eventData] of this.namedListeners[identifier][eventName]) {
        results.push(eventData._callback.call(eventData._context, data));
      }
    } else {
      if (!this.globalListeners[eventName]) return [];
      for (let [key, eventData] of this.globalListeners[eventName]) {
        results.push(eventData._callback.call(eventData._context, data));
      }
    }
    return results;
  }
  static removeSubscriber(eventName: string, identifier: string, subscriberName: string): boolean {
    if (identifier) {
      if (
        this.namedListeners[identifier] &&
        this.namedListeners[identifier][eventName] &&
        this.namedListeners[identifier][eventName].has(subscriberName)
      ) {
        this.namedListeners[identifier][eventName].delete(subscriberName);
        return true;
      }
    } else {
      if (this.globalListeners[eventName] && this.globalListeners[eventName].has(subscriberName)) {
        this.globalListeners[eventName].delete(subscriberName);
        return true;
      }
    }
    return false;
  }
  static subscribeDefaultEvents() {
    EventSystem.subscribe(this.list.STRUCTURE_BEFORE_LOAD, function (json: IStructure) {
      StructurePreprocessing.normalizeXpaths(json);
      StructurePreprocessing.initAutocompletes(json);
      StructurePreprocessing.initRadioButtonListSections(json);
      StructurePreprocessing.initTables(json);
      StructurePreprocessing.initFunctionalityPreprocessing(json);
      StructurePreprocessing.initOverlays(json);
      StructurePreprocessing.initXmlXsltValidationOverlay(json);
    });
    EventSystem.subscribe(this.list.ENGINE_READY, function (engine: FormEngine) {
      if (window.xmlToImport) {
        console.log("Before xmlToImport call",window.xmlToImport);
        window.FormEngine.xmlService.importXmlFromString(window.xmlToImport, true);
        window.xmlToImport = null;
      }
    });
  }
}
